// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1306":"a815abf4ec8f0616","3872":"8959fd3f7ca85127"}[chunkId] + ".css";
};